<div class="reactive-toolbar" [@header]="visibility">
  <ng-content></ng-content>
</div>
